import { useEffect } from 'react';

export default function CrispManager() {
  useEffect(() => {
    if (!window.$crisp) window.$crisp = [];
    window.$crisp.push([
      'on',
      'chat:closed',
      () => {
        window.$crisp.push(['do', 'chat:hide']);
      }
    ]);
  }, []);

  return null;
}
